import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material/SvgIcon/SvgIcon';
import { isString } from 'lodash';
import React, { createElement, FC } from 'react';
import classNames from 'classnames';

import { useStyles } from './StartMenuItemIcon.styles';

interface MenuItemIconProps {
  icon: string | OverridableComponent<SvgIconTypeMap>;
  isActive?: boolean;
  width?: number;
  height?: number;
  iconWidth?: number;
}

export const StartMenuItemIcon: FC<MenuItemIconProps> = ({
  icon,
  isActive = false,
  width = 3.75,
  height = 3.75,
  iconWidth = 2,
}) => {
  const { classes } = useStyles({ containerHight: height, containerWidth: width, iconWidth });

  if (!icon) {
    return null;
  }

  if (isString(icon)) {
    return (
      <i className={classNames(classes.root, { [classes.activeIcon]: isActive })}>
        <img className={classes.icon} src={icon} alt={icon} />
      </i>
    );
  }

  return (
    <i className={classNames(classes.root, { [classes.activeIcon]: isActive })}>
      {createElement(icon, { className: classes.icon })}
    </i>
  );
};
